import { ContractSettingType } from '@/components/features/ContractSetting/types'
import { statusOptions } from '@/components/features/CustomerContract/types'

export type CustomerContractsNewPropsType = {
  contractSetting?: Omit<ContractSettingType, 'status'>
  folderId?: string
}

export type CustomerContractsEditPropsType = {
  contractSetting?: Omit<ContractSettingType, 'status' | 'approverSettings'>
  readonly id: string
  folderId?: string
  currentUserId: string
  permissionType: string
  customerAnswerPageUrl: string
  customerAnswerPageImageSrc: string
}

export type CustomerContractsSearchFormPropsType = {
  folderId?: string
  searchParams: {
    folderIds: string[] | null
    name: string
    approverId: string | null
    customer: {
      id: string
      lastName: string
      firstName: string
    } | null
    contractSetting: {
      id: string
      name: string
    } | null
    status: typeof statusOptions[number]['value'] | null
    createdAtStart: string | null
    createdAtEnd: string | null
  }
  contractSettings: {
    id: string
    name: string
    folderName: string | null
  }[]
  folders: {
    id: string
    name: string
  }[]
  approvers: {
    id: string
    lastName: string
    firstName: string
  }[]
}

export type SearchFormType = {
  selectedFolders: {
    value: string
    label: string
  }[]
  name: string
  selectedContractSetting: {
    value: string
    label: string
  } | null
  selectedApprover: {
    value: string
    label: string
  } | null
  selectedCustomer: {
    value: string
    label: string
  } | null
  statusOption: typeof statusOptions[number] | { value: ''; label: string } | null
  createdAtStart: string | null
  createdAtEnd: string | null
}

export const stepOptions = [
  { label: 'タイトル・PDF', value: 'basic_info' },
  { label: 'クライアント情報', value: 'customer_forms' },
  { label: '契約内容の入力', value: 'answer_item_forms' },
  { label: '署名欄の設定', value: 'invitee_field_forms' },
  { label: '送信内容の確認', value: 'confirmation' },
  { label: '署名の確認', value: 'signature_check' },
] as const
